module.exports = __webpack_public_path__ + "static/media/seagrass.fad25cf7.jpg";